import React from 'react';
import { themes } from './theme';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || 'Unexpected app error' };
  }

  componentDidCatch(error, info) {
    console.error('Weekly Planner error:', error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    const theme = themes.light;

    return (
      <div style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        padding: 20,
        background: theme.bg,
        backgroundImage: theme.bgImage,
        color: theme.text,
        fontFamily: "'Rajdhani', sans-serif",
      }}>
        <div style={{
          width: 'min(520px, 100%)',
          border: `1px solid ${theme.border}`,
          borderRadius: 10,
          background: theme.glassStrong,
          boxShadow: theme.shadowStrong,
          padding: 24,
        }}>
          <h1 style={{
            margin: 0,
            color: theme.primary,
            fontFamily: "'Orbitron', sans-serif",
            fontSize: 24,
          }}>
            Something went wrong
          </h1>
          <p style={{ color: theme.muted, lineHeight: 1.5 }}>
            Weekly Planner hit a temporary problem. Your saved planner data stays in Supabase, so reloading is the safest next step.
          </p>
          <pre style={{
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            border: `1px solid ${theme.borderSoft}`,
            borderRadius: 8,
            padding: 10,
            color: theme.danger,
            background: theme.dangerSoft,
            fontSize: 13,
          }}>
            {this.state.message}
          </pre>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              marginTop: 14,
              border: `1px solid ${theme.primary}`,
              borderRadius: 8,
              background: `linear-gradient(135deg, ${theme.primary}, ${theme.secondary})`,
              color: '#ffffff',
              padding: '10px 14px',
              cursor: 'pointer',
              fontWeight: 900,
              fontFamily: "'Orbitron', sans-serif",
            }}
          >
            Reload planner
          </button>
        </div>
      </div>
    );
  }
}
